export type AnalyticsDays = 7 | 30

export type AnalyticsOverview = {
  days: AnalyticsDays
  summary: {
    sessions: number
    pageViews: number
    toolSuccesses: number
    topSource: string
  }
  topSources: Array<{
    source: string
    sessions: number
  }>
  topLandingPages: Array<{
    path: string
    pageViews: number
  }>
}

export type AnalyticsTools = {
  days: AnalyticsDays
  rows: Array<{
    toolId: string
    toolName: string
    toolCategory: string
    viewCount: number
    submitCount: number
    successCount: number
    successRate: number
  }>
}

const storageKey = 'ops-analytics-token'

export const getOpsAnalyticsToken = () => sessionStorage.getItem(storageKey) || ''

export const setOpsAnalyticsToken = (token: string) => {
  sessionStorage.setItem(storageKey, token)
}

export const clearOpsAnalyticsToken = () => {
  sessionStorage.removeItem(storageKey)
}

const readErrorMessage = async (response: Response) => {
  try {
    const payload = await response.json()
    if (payload && typeof payload.error === 'string') return payload.error
  } catch {
    // ignore
  }

  return '统计数据暂时不可用，请稍后重试'
}

const fetchWithToken = async <T>(path: string, token: string): Promise<T> => {
  const response = await fetch(path, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })

  if (!response.ok) {
    throw new Error(await readErrorMessage(response))
  }

  return response.json() as Promise<T>
}

export const fetchAnalyticsOverview = (days: AnalyticsDays, token: string) =>
  fetchWithToken<AnalyticsOverview>(`/api/analytics/overview?days=${days}`, token)

export const fetchAnalyticsTools = (days: AnalyticsDays, token: string) =>
  fetchWithToken<AnalyticsTools>(`/api/analytics/tools?days=${days}`, token)
